import { Action } from '@ngrx/store';

export const SELECT_ADDRESS = 'SELECT_ADDRESS';

export class SelectAddress implements Action {
  type = SELECT_ADDRESS;

  constructor(public payload?: any) {}
}

export type Actions = SelectAddress;
